import { render, staticRenderFns } from "./EditSon.vue?vue&type=template&id=e03867d4&scoped=true&"
import script from "./EditSon.vue?vue&type=script&lang=js&"
export * from "./EditSon.vue?vue&type=script&lang=js&"
import style0 from "./EditSon.vue?vue&type=style&index=0&id=e03867d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e03867d4",
  null
  
)

export default component.exports